import { ProjectSettingsMapper } from '../mapper/ProjectSettingsMapper';

export const projectSettingsMapper = new ProjectSettingsMapper();
